// `.mjs`, not `.js`: the root tests import this under CI's Node 21, which cannot load ESM
// from a `.js` file with no "type" field (#41).
export const REDIRECTS = [
    { from: '/backoffice', to: '/controller', subpaths: true },
    { from: '/timestamp', to: '/display', subpaths: false },
]

// Mirrors vue-router's default matching (sensitive: false, strict: false) so a path the
// redirect records match is the same path this function redirects.
function matches(path, { from, subpaths }) {
    const normalised = path.toLowerCase().replace(/(.)\/$/, '$1')
    return normalised === from || (subpaths && normalised.startsWith(`${from}/`))
}

export function decideNavigation(fullPath) {
    const pathEnd = fullPath.search(/[?#]/)
    const path = pathEnd === -1 ? fullPath : fullPath.slice(0, pathEnd)
    const queryAndHash = pathEnd === -1 ? '' : fullPath.slice(pathEnd)

    const redirect = REDIRECTS.find((entry) => matches(path, entry))
    if (!redirect) {
        return { kind: 'proceed' }
    }
    return { kind: 'redirect', to: `${redirect.to}${queryAndHash}` }
}
